var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded,
      "error": _vm.onBillboardError
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": _vm.$safeUrl(link.u)
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  }), _vm._v(" "), (_vm.showVideo) ? _c('div', {
    staticClass: "homepage-animated"
  }, [_c('video', {
    attrs: {
      "id": "billboard-video",
      "src": _vm.s3VidSrc,
      "autoplay": "",
      "muted": "",
      "controls": ""
    },
    domProps: {
      "muted": true
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-3 honk-text"
  }, [(!_vm.showVideo) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.playVideo
    }
  }, [_vm._v("ANIMATE")]) : _vm._e(), _vm._v(" "), (_vm.showVideo) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.playVideo
    }
  }, [_vm._v("STOP 🛑")]) : _vm._e(), _vm._v(" "), (!_vm.inspectMode) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.toggleInspect
    }
  }, [_vm._v("INSPECT")]) : _vm._e(), _vm._v(" "), (_vm.inspectMode) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.toggleInspect
    }
  }, [_vm._v("LINKS 🔗")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": function($event) {
        return _vm.$router.push('/break')
      }
    }
  }, [_vm._v("BREAK 🕹️")])]), _vm._v(" "), (_vm.inspectMode && !_vm.inspectTrx) ? _c('div', {
    staticClass: "inspect-hint"
  }, [_vm._v("Select some pixels to inspect them")]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx) ? _c('div', {
    attrs: {
      "id": "plot-inspect"
    }
  }, [_c('div', {
    staticClass: "inspect-card"
  }, [_c('router-link', {
    staticClass: "inspect-image-link",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_c('img', {
    attrs: {
      "src": 'https://millionbithomepage.com/seq/' + _vm.inspectTrx.seq + '/token.jpeg'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inspect-details"
  }, [_c('div', {
    staticClass: "inspect-header"
  }, [_c('router-link', {
    staticClass: "inspect-title",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_vm._v("Plot #" + _vm._s(_vm.inspectTrx.tokenId))]), _vm._v(" "), _c('span', {
    staticClass: "inspect-size"
  }, [_vm._v(_vm._s(_vm.inspectTrx.x2 - _vm.inspectTrx.x1) + "x" + _vm._s(_vm.inspectTrx.y2 - _vm.inspectTrx.y1) + "px")])], 1), _vm._v(" "), _c('a', {
    staticClass: "inspect-url",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.url),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.inspectTrx.url))]), _vm._v(" "), (_vm.inspectTrx.profile) ? _c('div', {
    staticClass: "inspect-links"
  }, [(_vm.inspectTrx.profile.base_name) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://base.org/name/' + _vm.inspectTrx.profile.base_name.replace('.base.eth', ''),
      "target": "_blank",
      "title": "Base Name"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 111 111",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
      "fill": "#0052FF"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.website_url && _vm.inspectTrx.profile.website_url !== _vm.inspectTrx.url) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.profile.website_url),
      "target": "_blank",
      "title": "Website"
    }
  }, [_c('svg', {
    staticClass: "bi bi-link-45deg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.x_username) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://x.com/' + _vm.inspectTrx.profile.x_username,
      "target": "_blank",
      "title": "X / Twitter"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.tg_url) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.profile.tg_url),
      "target": "_blank",
      "title": "Telegram"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.token_ca) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://dexscreener.com/base/' + _vm.inspectTrx.profile.token_ca,
      "target": "_blank",
      "title": "Token Chart"
    }
  }, [_c('svg', {
    staticClass: "bi bi-graph-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.nft_ca) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://magiceden.us/collections/base/' + _vm.inspectTrx.profile.nft_ca,
      "target": "_blank",
      "title": "NFT Collection"
    }
  }, [_c('svg', {
    staticClass: "bi bi-images",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-dark btn-sm inspect-view-btn",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_vm._v("View Plot Details")])], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e55d30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage.vue
// module id = pEEw
// module chunks = 6